module.exports = __webpack_public_path__ + "static/media/2020-01-30 smart-questions.99f27588.md";